import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { AppRouter } from '@MASTER';
import { useAuthority } from '@HOOKS';
import CompanyInfo from './company-info';

const Infos = () => {
  let { path } = useRouteMatch();

  return (
    <div className="app-definitions">
      {
        <AppRouter path={`${path}/company-info`} title="Firma Bilgilerim">
          <CompanyInfo />
        </AppRouter>
      }
    </div>
  );
};

export default Infos;
